import type { ButtonProps } from '@mui/material';
import { Button } from '@mui/material';
import { VyIcon } from '@weft/icons';
import React from 'react';

export const FilterButton: React.FC<ButtonProps> = (props) => {
  return (
    <Button
      variant="outlined"
      size="large"
      endIcon={<VyIcon icon="Filter"/>}
      children="Filters"
      {...props}
    />
  );
};